// Costanti calendario — etichette IT, layout 7 giorni Lun→Dom, viste supportate.
export const MONTH_LABELS_IT = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];
export const MONTH_SHORT = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
export const GIORNI_FULL = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
export const GIORNI_SHORT = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
export const VIEWS = ['mese', 'trimestre', 'settimana'];

/**
 * Tinta heatmap della cella in base a `stato` + `pct` (0..1) MIT fatte.
 *   - 'vuoto'         → trasparente
 *   - 'tutte_fatte'   → verde sfumato
 *   - 'tutte_da_fare' → rosso sfumato leggero
 *   - 'parziale'      → ambra in funzione di pct
 */
export function heatmapBg(stato, pct) {
  if (stato === 'vuoto') return 'rgba(212, 212, 212, 0.0)';
  if (stato === 'tutte_fatte') return 'rgba(22, 163, 74, 0.10)';
  if (stato === 'tutte_da_fare') return 'rgba(229, 72, 77, 0.06)';
  const a = 0.05 + 0.18 * (pct || 0);
  return `rgba(245, 158, 11, ${a.toFixed(2)})`;
}
